import React, { useLayoutEffect, useRef, useState } from "react";
import prevnextPage from "../../assets/images/prevnextPage.svg";
import "../Table/table.scss";
import AccessibleTooltip from "../Tooltip/Tooltip";

const Pagination = ({
  page,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange
}) => {
  const prevBtnRef = useRef(null);
  const nextBtnRef = useRef(null);
  const [prevPage, setPrevPage] = useState(page);
  const [focusedBtn, setFocusedBtn] = useState(null); // "prev" | "next" | null

  useLayoutEffect(() => {
    if (prevPage === 2 && page === 1) {
      nextBtnRef.current?.focus();
    }
    setPrevPage(page);
  }, [page, prevPage]);

  return (
    <div className="pagination-custom">
      <span
        className="range-text"
        aria-live="polite"
        aria-atomic="true"
        aria-hidden="true"
      >
        {` Page ${page} of ${totalPages}`}
      </span>

      <span
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {`Page ${page} of ${totalPages}`}
      </span>

      <AccessibleTooltip title="Previous Page" open={focusedBtn === "prev"}>
        <button
          onClick={() => {
            if (page > 1) onPageChange(page - 1);
          }}

          ref={prevBtnRef}
          onFocus={() => setFocusedBtn("prev")}
          onBlur={() => setFocusedBtn(null)}
          // disabled={page === 1}
          aria-disabled={page === 1}
          tabIndex={page === 1 ? -1 : 0}
          className="page-btn prevbtn"
          aria-label={`Previous Page, currently on page ${page} of ${totalPages}`}
          style={{opacity:`${page === 1 ? 0.5 : 1}`}}
        >
          <img src={prevnextPage} alt="" aria-hidden="true" />
        </button>
      </AccessibleTooltip>

      <AccessibleTooltip title="Next Page" open={focusedBtn === "next"}>
        <button
          ref={nextBtnRef}
          onFocus={() => setFocusedBtn("next")}
          onBlur={() => setFocusedBtn(null)}
          onClick={() => {
              if (page < totalPages) {
                const nextPage = page + 1;
                onPageChange(nextPage);
                if (nextPage === totalPages) {
                  setTimeout(() => {
                    prevBtnRef.current?.focus();
                  }, 200);
                }
              }
            }}
          // disabled={page === totalPages}
            aria-disabled={page === totalPages}
          tabIndex={page === totalPages ? -1 : 0}
          className="page-btn nextbtn"
          aria-label={`Next Page, currently on page ${page} of ${totalPages}`}
          style={{opacity:`${page === totalPages ? 0.5 : 1}`}}
        >
          <img src={prevnextPage} alt="" aria-hidden="true" />
        </button>
      </AccessibleTooltip>
    </div>
  );
};

export default Pagination;
